import { useView } from 'aurelia-framework';
import { computedFrom } from "aurelia-binding";
import { autoinject } from "aurelia-dependency-injection";
import { Claims } from "../../../../../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../../../../../services/authentication/user-claims.service";
import { DateHelper } from "../../../../../../../../utilities/date-helper";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { CompBannerCrewWelfareModel } from '@rightship-tech/common-ui/components/comp-banner-crew-welfare/comp-banner-crew-welfare';
import { Router } from 'aurelia-router';
import { RightShipQiRouterConstants } from '../../../../../../../../configuration/rightshipqi-router.constants';

@autoinject
@useView('views/pages/modules/company/tabs/social/tabs/crew-welfare/company-crew-welfare.html')
export class CompanyCrewWelfare {

    isRightShipUser: boolean;
    canAccessCrewWelfare: boolean;
    item: CompBannerCrewWelfareModel;

    @computedFrom("item.crewWelfareValidUntil")
    get daysUntilCrewWelfareExpires(): number {
        const today = new Date();
        return DateHelper.daysBetweenDates(today.toString(), this.item.crewWelfareValidUntil.toString())
    }

    @computedFrom("item.crewWelfareStatus", "item.crewWelfareValidUntil")
    get isCrewWelfareExpiring(): boolean {
        const expiringCounterLength: number = 90;
        if (this.item.crewWelfareStatus == 'Submitted') {
            if (this.daysUntilCrewWelfareExpires < expiringCounterLength)
                return true
        }
    }

    @computedFrom("configService.config.urls.crewWelfareUrl")
    get crewWelfareUri() {
        return this.configService.config.urls.crewWelfareUrl;
    }

    constructor(userClaimsService: UserClaimsService, private configService: ConfigService, private router: Router) {
        this.isRightShipUser = userClaimsService.hasPermission(Claims.RightShipUser);
        this.canAccessCrewWelfare = userClaimsService.hasPermission(Claims.CanAccessCrewWelfare);
    }

    activate(item: CompBannerCrewWelfareModel) {
        this.item = item;
    }

    viewSubmission() {
        if (this.item.isLegacyCrewWelfare) {
            this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.Activities);
        } else {
            this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.Cwsa, { cwSelfAssessmentGuid: this.item.crewWelfareGuid });
        }
    }
}